interface Props {
  stability: number; // 0–1
}

const LABELS = ['Shaky', 'Unstable', 'Fair', 'Stable', 'Solid', 'Perfect'];

export default function StabilityMeter({ stability }: Props) {
  const pct = Math.round(stability * 100);
  const label = LABELS[Math.floor(stability * (LABELS.length - 1))];

  const barColor = stability > 0.75 ? '#4ade80'
    : stability > 0.45 ? '#facc15'
    : '#f87171';

  return (
    <div className="rounded-xl p-3" style={{ background: 'rgba(22,18,58,0.8)', border: '1px solid rgba(83,74,183,0.3)' }}>
      <div className="flex justify-between items-center mb-2">
        <span className="text-xs tracking-widest uppercase" style={{ color: '#AFA9EC' }}>Stability</span>
        <span className="text-sm font-mono font-bold" style={{ color: barColor }}>{label}</span>
      </div>

      {/* Bar */}
      <div className="relative h-2 rounded-full overflow-hidden" style={{ background: 'rgba(83,74,183,0.2)' }}>
        <div
          className="absolute inset-y-0 left-0 rounded-full transition-all duration-150"
          style={{ width: `${pct}%`, background: barColor, boxShadow: `0 0 8px ${barColor}60` }}
        />
      </div>

      {/* Vibrato dots — show when mid-stability (vibrato zone) */}
      {stability > 0.3 && stability < 0.75 && (
        <p className="mt-1 text-xs" style={{ color: 'rgba(174,169,236,0.6)' }}>
          Vibrato detected — control your breath
        </p>
      )}
    </div>
  );
}
